import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';

import Layout from '@/components/layout/LayoutWrapper';
import EnSubmissionsMDX from '@/markdown/terms/submissions/en.mdx';
import { Locale } from '@/store/locale/types';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

interface LocaleMdxProps {}

/*
 * Need to use switch statement due to need for static strings in `import` function within `dynamic()`
 * https://nextjs.org/docs/advanced-features/dynamic-import
 * This might eventually get fixed: https://github.com/vercel/next.js/discussions/33980
 */
const localeMdx = (locale: Locale = 'en') => {
	const defaultMDX = EnSubmissionsMDX;

	switch (locale) {
		case 'it':
			return dynamic<LocaleMdxProps>(() =>
				import('@/markdown/terms/submissions/it.mdx').then(mdx => mdx).catch(() => defaultMDX),
			);
		case 'pl':
			return dynamic<LocaleMdxProps>(() =>
				import('@/markdown/terms/submissions/pl.mdx').then(mdx => mdx).catch(() => defaultMDX),
			);
		case 'zh':
			return dynamic<LocaleMdxProps>(() =>
				import('@/markdown/terms/submissions/zh.mdx').then(mdx => mdx).catch(() => defaultMDX),
			);

		// English fallback
		case 'en':
		default:
			return defaultMDX;
	}
};

const SubmissionsTerms = ({ initialState: { locale } }: { initialState: { locale: Locale } }) => {
	const LocaleMdx = localeMdx(locale);
	// TODO: refactor this code to follow best practices
	/* eslint-disable react-hooks/static-components */
	return (
		<Layout pageName="submissions-policy" title="Calm - Unsolicited Submissions Policy">
			<LocaleMdx />
		</Layout>
	);
	/* eslint-enable react-hooks/static-components */
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	return {
		props: {
			initialState,
			hideAcceptCookiesModal: true,
		},
	};
};

export default SubmissionsTerms;
